import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TransactionGuard, RoleGuard, SigepeSegurancaModule } from '@sigepe/ngx-sigepe-seguranca';

import { Error404Component, ForbiddenComponent, SigepeMainLayoutModule, UnauthorizedComponent } from '@sigepe/sigepe-template';
import { MainComponent } from './components/pages/main/main.component';
import { BuscarAgentePublicoComponent } from './components/pages/gerenciar-ferias/buscar-agente-publico/buscar-agente-publico.component';
import { ConsultarExerciciosComponent } from './components/pages/gerenciar-ferias/consultar-exercicios/consultar-exercicios.component';
import { GerenciarFeriasComponent } from './components/pages/gerenciar-ferias/gerenciar-ferias.component';
import { ProgramarFeriasComponent } from './components/pages/gerenciar-ferias/programar-ferias/programar-ferias.component';
import { ReprogramarFeriasComponent } from './components/pages/gerenciar-ferias/reprogramar-ferias/reprogramar-ferias.component';
import { HomologarFeriasComponent } from './components/pages/gerenciar-ferias/homologar-ferias/homologar-ferias.component';
import { DetalharFeriasComponent } from './components/pages/gerenciar-ferias/detalhar-ferias/detalhar-ferias.component';
import { InterromperFeriasComponent } from './components/pages/gerenciar-ferias/interromper-ferias/interromper-ferias.component';
import { CancelarInterrupcaoComponent } from './components/pages/gerenciar-ferias/cancelar-interrupcao/cancelar-interrupcao.component';
import { FeriasEspeciaisAdministrativasComponent } from './components/pages/gerenciar-ferias/ferias-especiais-administrativas/ferias-especiais-administrativas.component';
import { FeriasEspeciaisAdministrativasComParcelasComponent } from './components/pages/gerenciar-ferias/ferias-especiais-administrativas-com-parcelas/ferias-especiais-administrativas-com-parcelas.component';
import { FeriasEspeciaisJudiciaisComponent } from './components/pages/gerenciar-ferias/ferias-especiais-judiciais/ferias-especiais-judiciais.component';
import { FeriasEspeciaisJudiciaisComParcelasComponent } from './components/pages/gerenciar-ferias/ferias-especiais-judiciais-com-parcelas/ferias-especiais-judiciais-com-parcelas.component';
import { HistoricoTramitacaoProcessoComponent } from './components/pages/historico-tramitacao-processo/historico-tramitacao-processo.component';
import { EnumTransacao } from './components/shared/enums/transacao.enum';
import { EnumPerfil } from './components/shared/enums/perfil.enum';
import { EnviarHomologacaoParaFolhaComponent } from './components/pages/gerenciar-ferias/enviar-homologacao-para-folha/enviar-homologacao-para-folha.component';
import { ConsultaGerencialComponent } from './components/pages/consulta-gerencial/consulta-gerencial.component';

const routes: Routes = [
    {
        path: '',
        component: MainComponent,
        data: {
            breadcrumb: 'Página Inicial',
            roles: [EnumPerfil.FERIAS_ADM.descricao, EnumPerfil.FERIAS_GESTOR.descricao, EnumPerfil.FERIAS_OPERACIONAL.descricao, EnumPerfil.FERIAS_CONSULTA_RH.descricao],
            showInMenu: true
        },
        canActivate: [RoleGuard]
    },
    {
        path: 'secure/gerenciar-ferias',
        component: GerenciarFeriasComponent,
        data: {
            breadcrumb: 'Gerenciar Férias',
            transactions: [EnumTransacao.FERIAS_BUSCAR_AGENTE_PUBLICO.descricao],
            showInMenu: true
        },
        canActivate: [TransactionGuard],
        children: [
            {
                path: 'buscar-agente-publico',
                component: BuscarAgentePublicoComponent,
                data: {
                    //breadcrumb: 'Buscar Agente Público',
                    transactions: [EnumTransacao.FERIAS_BUSCAR_AGENTE_PUBLICO.descricao],
                    showInMenu: false
                },
                canActivate: [TransactionGuard]
            },
            {
                path: 'consultar-exercicios',
                component: ConsultarExerciciosComponent,
                data: {
                    breadcrumb: 'Consultar Exercícios',
                    transactions: [EnumTransacao.FERIAS_CONSULTAR_EXERCICIO.descricao],
                    showInMenu: false
                },
                canActivate: [TransactionGuard],
                children: [
                    {
                        path: 'programar-ferias',
                        component: ProgramarFeriasComponent,
                        data: {
                            breadcrumb: 'Programar Férias',
                            transactions: [EnumTransacao.FERIAS_PROGRAMAR.descricao],
                            showInMenu: false
                        },
                        canActivate: [TransactionGuard]
                    },
                    {
                        path: 'reprogramar-ferias',
                        component: ReprogramarFeriasComponent,
                        data: {
                            breadcrumb: 'Reprogramar Férias',
                            transactions: [EnumTransacao.FERIAS_REPROGRAMAR.descricao],
                            showInMenu: false
                        },
                        canActivate: [TransactionGuard]
                    },
                    {
                        path: 'homologar-ferias',
                        component: HomologarFeriasComponent,
                        data: {
                            breadcrumb: 'Homologar Férias',
                            transactions: [EnumTransacao.FERIAS_HOMOLOGAR.descricao],
                            showInMenu: false
                        },
                        canActivate: [TransactionGuard]
                    },
                    {
                        path: 'interromper-ferias',
                        component: InterromperFeriasComponent,
                        data: {
                            breadcrumb: 'Interromper Férias',
                            transactions: [EnumTransacao.FERIAS_INTERROMPER.descricao],
                            showInMenu: false
                        },
                        canActivate: [TransactionGuard]
                    },
                    {
                        path: 'cancelar-interrupcao',
                        component: CancelarInterrupcaoComponent,
                        data: {
                            breadcrumb: 'Cancelar Interrupção',
                            transactions: [EnumTransacao.FERIAS_CANCELAR_INTERRUPCAO.descricao],
                            showInMenu: false
                        },
                        canActivate: [TransactionGuard]
                    },
                    {
                        path: 'detalhar-ferias',
                        component: DetalharFeriasComponent,
                        data: {
                            breadcrumb: 'Detalhar Férias',
                            transactions: [EnumTransacao.FERIAS_DETALHAR.descricao],
                            showInMenu: false
                        },
                        canActivate: [TransactionGuard]
                    },
                    {
                        path: 'ferias-especiais-administrativas',
                        component: FeriasEspeciaisAdministrativasComponent,
                        data: {
                            breadcrumb: 'Férias Especiais Administrativas',
                            transactions: [EnumTransacao.FERIAS_ESPECIAIS_ADMINISTRATIVA.descricao],
                            showInMenu: false
                        },
                        canActivate: [TransactionGuard]
                    },
                    {
                        path: 'ferias-especiais-administrativas-com-parcelas',
                        component: FeriasEspeciaisAdministrativasComParcelasComponent,
                        data: {
                            breadcrumb: 'Férias Especiais Administrativas',
                            transactions: [EnumTransacao.FERIAS_ESPECIAIS_ADMINISTRATIVA.descricao],
                            showInMenu: false
                        },
                        canActivate: [TransactionGuard]
                    },
                    {
                        path: 'ferias-especiais-judiciais',
                        component: FeriasEspeciaisJudiciaisComponent,
                        data: {
                            breadcrumb: 'Férias Especiais Judiciais',
                            transactions: [EnumTransacao.FERIAS_ESPECIAIS_JUDICIAL.descricao],
                            showInMenu: false
                        },
                        canActivate: [TransactionGuard]
                    },
                    {
                        path: 'ferias-especiais-judiciais-com-parcelas',
                        component: FeriasEspeciaisJudiciaisComParcelasComponent,
                        data: {
                            breadcrumb: 'Férias Especiais Judiciais',
                            transactions: [EnumTransacao.FERIAS_ESPECIAIS_JUDICIAL.descricao],
                            showInMenu: false
                        },
                        canActivate: [TransactionGuard]
                    }
                ]
            }
        ]
    },
    {
        path: 'secure/consulta-gerencial',
        data: {
            title: 'Consulta Gerencial',
            breadcrumb: 'Consulta Gerencial',
            transactions: [EnumTransacao.FERIAS_CONSULTA_GERENCIAL.descricao],
            showInMenu: true
        },
        canActivate: [TransactionGuard],
        children: [
            {
                path: '',
                pathMatch: 'full',
                component: ConsultaGerencialComponent
            },
            {
                path: 'programar-ferias',
                component: ProgramarFeriasComponent,
                data: {
                    breadcrumb: 'Programar Férias',
                    transactions: [EnumTransacao.FERIAS_PROGRAMAR.descricao],
                    showInMenu: false
                },
                canActivate: [TransactionGuard]
            },
            {
                path: 'homologar-ferias',
                component: HomologarFeriasComponent,
                data: {
                    breadcrumb: 'Homologar Férias',
                    transactions: [EnumTransacao.FERIAS_HOMOLOGAR.descricao],
                    showInMenu: false
                },
                canActivate: [TransactionGuard]
            },
            {
                path: 'detalhar-ferias',
                component: DetalharFeriasComponent,
                data: {
                    breadcrumb: 'Detalhar Férias',
                    transactions: [EnumTransacao.FERIAS_DETALHAR.descricao],
                    showInMenu: false
                },
                canActivate: [TransactionGuard]
            }
        ]
    },
    {
        path: 'unauthorized',
        data: {
            title: 'Acesso não autorizado',
            breadcrumb: 'Acesso não autorizado',
            showInMenu: false
        },
        component: UnauthorizedComponent
    },
    {
        path: 'forbidden',
        data: {
            title: 'Acesso não autorizado',
            breadcrumb: 'Acesso não autorizado',
            showInMenu: false
        },
        component: ForbiddenComponent
    },
    {
        path: 'enviar-homologacao-para-folha',
        data: {
            title: 'Enviar Homologação para Folha',
            breadcrumb: 'Enviar Homologação para Folha',
            showInMenu: false
        },
        component: EnviarHomologacaoParaFolhaComponent
    },
    /*{
    path: 'historico-tramitacao-processo',
    data: {
      title: 'Histórico de Tramitação do Processo de Férias',
      breadcrumb: 'Histórico de Tramitação do Processo de Férias',
      showInMenu: true
    },
    component: HistoricoTramitacaoProcessoComponent
  },*/
    {
        path: '**',
        component: Error404Component,
        data: { breadcrumb: 'Página não encontrada', showInMenu: false }
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            onSameUrlNavigation: 'reload',
            useHash: false
        }),
        SigepeMainLayoutModule,
        SigepeSegurancaModule
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {}
